import {Component, OnDestroy, OnInit} from '@angular/core';
import {Router, RouterModule, RouterOutlet, NavigationEnd} from '@angular/router';
import {Subscription} from 'rxjs';
import {AuthService} from '../../data-access-layer/services/auth.service';
import { User } from '../../data-access-layer/interfaces/users.interface';
import { AfterViewInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { HttpClient } from '@angular/common/http';
import { SourceService } from '../../data-access-layer/services/sources.service';
import { CommonModule } from '@angular/common';
import { UserSessionStorageService } from '../../data-access-layer/services/user-sessions.service';
import { TranslocoService } from '@ngneat/transloco';
import { LanguageSelectorComponent } from './language-selector.component';
import { TranslocoModule} from '@ngneat/transloco';
import { saveAs } from 'file-saver-es';
import { LoadingChatComponent } from './loading_chat.component';
import { filter } from 'rxjs/operators';
import { ChatComponent } from './chat.component';
import { AutoScaleDirective } from '../../shared/directives/auto-scale.directive';
import { LoadingService } from '../../data-access-layer/services/loading.service';
import { LoadingComponent } from './loading.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterModule, RouterOutlet, CommonModule, LanguageSelectorComponent, TranslocoModule, LoadingChatComponent, ChatComponent, AutoScaleDirective, LoadingComponent],
  templateUrl: '../templates/app.component.html',
  styleUrl: '../templates/styles/app.component.css',
})


export class AppComponent implements OnInit, OnDestroy, AfterViewInit {
  public isAdmin: boolean = false;
  public currentUser: User | undefined;
  authButtonText: string = 'Войти';
  hoverText: string = 'Выйти';
  private userSubscription!: Subscription;
  private routerSubscription!: Subscription;
  pageHtml: SafeHtml | null = null;
  isMenuHidden = false;
  isRedirected = false;
  isShowBI: boolean = false;
  isChatVisible: boolean = false;
  isContentPage: boolean = false;
  isLoading = false;

  constructor(public authService: AuthService, private router: Router, private sanitizer: DomSanitizer, private http: HttpClient, private sessionService: UserSessionStorageService, public transloco: TranslocoService, private loadingService: LoadingService) {
    this.loadingService.loading$.subscribe((loading: boolean) => {
      this.isLoading = loading;
    });
  }

  ngOnInit(): void {
    const storedUser = this.sessionService.getItem('currentUser');
    if (storedUser) {
      const user: User = JSON.parse(storedUser);

      // проверка токена
      if (this.authService.isTokenValid()) {
        this.currentUser = user;
        this.authService.setCurrentUser(user);
        this.isAdmin = this.authService.isAdmin();
        this.authButtonText = this.currentUser.userName;
      } else {
        this.authService.logOut();
      }
    }

    else {
      this.router.navigate(['/auth']);
    }

    // Отслеживаем изменения роута
    this.checkCurrentRoute();
    this.routerSubscription = this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        this.checkCurrentRoute();
      });
  }

  private checkCurrentRoute(): void {
    this.isContentPage = this.router.url === '/content' || this.router.url.startsWith('/content');
    if (this.isContentPage) {
      // Получаем isShowBI из sessionStorage
      const restoreIsBI = this.sessionService.getItem('isBI');
      this.isShowBI = restoreIsBI === true || restoreIsBI === 'true';
      
      // Получаем isChatVisible из sessionStorage (если есть)
      const chatVisible = this.sessionService.getItem('isChatVisible');
      if (chatVisible !== null && chatVisible !== undefined) {
        this.isChatVisible = chatVisible === true || chatVisible === 'true';
      }
    } else {
      this.isChatVisible = false;
    }
  }

  onChatVisibleChange(visible: boolean): void {
    this.isChatVisible = visible;
    if (this.isContentPage) {
      this.sessionService.setItem('isChatVisible', visible);
    }
  }

  isTokenValid(token: string): boolean {
    if (!token) return false;
    const payload = JSON.parse(atob(token.split('.')[1]));
    const exp = payload.exp * 1000;
    return Date.now() < exp;
  }


  ngOnDestroy(): void {
    if (this.userSubscription) {
      this.userSubscription.unsubscribe();
    }
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }

  authAction(): void {
      this.sessionService.removeItem('currentUser');
      this.authService.setCurrentUser(undefined);
      this.isAdmin = false;
      this.authButtonText = "Войти";
  }

  onMouseEnter(): void {
    if (this.currentUser) {
      this.authButtonText = this.hoverText;
    }
  }

  onMouseLeave(): void {
    if (this.currentUser) {
      this.authButtonText = this.currentUser.userName;
    }
  }

  downloadDocument(): void {
    const fileName = 'Пользовательская_документация_Datadesc_AI.docx';
    const filePath = `/assets/${fileName}`;
    
    this.http.get(filePath, {
      responseType: 'blob'
    }).subscribe({
      next: (blob: Blob) => {
        try {
          saveAs(blob, fileName);
          console.log('Документация успешно скачана:', fileName);
        } catch (error: any) {
          console.error('Ошибка при скачивании документации:', error);
        }
      },
      error: (error: any) => {
        console.error('Ошибка при загрузке файла документации:', error);
      }
    });
  }

  async ngAfterViewInit(): Promise<void> {
    const html = document.documentElement.outerHTML;
    this.pageHtml = this.sanitizer.bypassSecurityTrustHtml(html);
  }

  toggleMenu(): void {
    this.isMenuHidden = !this.isMenuHidden;
  }

  closeMenu(): void {
    this.isMenuHidden = true;
  }

}
